/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const propTypes = {
  children: PropTypes.oneOfType[
    PropTypes.object,
    PropTypes.string
  ],
  closePopUp: PropTypes.func.isRequired,
  description: PropTypes.string,
  imageUrl: PropTypes.string.isRequired,
  isError: PropTypes.bool,
  title: PropTypes.string
};

const defaultProps = {
  description: "",
  isError: false,
  title: ""
};

const SubscribeConfirmation = ({
  isError,
  title,
  imageUrl,
  description,
  children,
  closePopUp
}) =>  (
  <PopUp>
    <ConfirmationWrapper>
      <ConfirmationContainer>
        <CoverImage
          alt="confirmation image"
          loading="lazy"
          src={imageUrl}
        />
        <Heading isError={isError}>
          {title}
        </Heading>
        <Text>
          {description}
        </Text>
        {children}
        <CloseButton onClick={closePopUp} />
      </ConfirmationContainer>
    </ConfirmationWrapper>
  </PopUp>
);

const PopUp = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

const ConfirmationWrapper = styled.div`
  width: 100%;
  text-align: center;
  overflow: hidden;
  display: flex;
  max-width: 1040px;
  justify-content: center;
  position: relative;
`;

const ConfirmationContainer = styled.div`
  position: relative;
  background: white;
  width: 50%;
  min-width: 300px;
  padding: 5rem;
  color: #464646;

  @media (max-width: 48em) {
    width: 90%;
    padding: 5rem 3rem;
    max-width: 400px;
  }
`;

const CoverImage = styled.img`
  width: 100%;
  max-width: 250px;
  margin-bottom: 2rem;
  max-height: 120px;
`;

const Heading = styled.h2`
  font-family: Avenir-Heavy;
  font-size: 2.6rem;
  line-height: 1.4;
  color: ${props => props.isError ? "#F7516F" : "#4688E2"};
`;

const CloseButton = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  background: transparent;
  border-radius: 50%;
  margin: 0.5rem;
  cursor: pointer;
  display: inline-block;

  &::before,
  &::after {
    content: "";
    margin-left: -12px;
    margin-top: -2px;
    left: 50%;
    top: 50%;
    width: 24px;
    height: 4px;
    background-color: #c3c9ec;
    position: absolute;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;

const Text = styled.p`
  font-family: Avenir-Light;
  font-size: 1.8rem;
  margin: 1rem auto 0;
  line-height: 1.5;
`;

SubscribeConfirmation.propTypes = propTypes;
SubscribeConfirmation.defaultProps = defaultProps;

export default SubscribeConfirmation;
